import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.jsx';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';
import './index.css';
import './styles/app-light-theme.css';
import './styles/global.css';
import './styles/embed-overrides.css';
import { isEmbedded } from './utils/embedMessaging';

// Importar fuentes de Google Fonts
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/orbitron/400.css';
import '@fontsource/orbitron/700.css';

// Marca <html> antes de montar React: neutraliza los "min-height: 100vh" de cada paso cuando
// el widget está embebido en un iframe (ver src/styles/embed-overrides.css para el porqué).
if (isEmbedded()) {
  document.documentElement.classList.add('is-embedded-widget');
}

// Buscar el elemento por ID específico
const container = document.getElementById('booking-widget');

// Solo montar la aplicación si el elemento existe
if (container) {
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <BrowserRouter>
        <AppErrorBoundary>
          <Routes>
            <Route path="/" element={<Navigate to="/en" replace />} />
            <Route path="/:lang" element={<App />} />
            <Route path="*" element={<Navigate to="/en" replace />} />
          </Routes>
        </AppErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>,
  )
}
